import { Badge, Grid } from '@mantine/core'

export const FilterCol = ({ text }) => {
  return (
    <>
      <Grid.Col
        span={{base: 6, lg: 6, xl: 6}}
        style={{textAlign: "center"}}
      >
        <Badge w={"90%"} 
          size="lg"
          color="#191919"
          styles={{
            root: {
              border: "1px solid #404040",
            }
          }}
        >
          {text}
        </Badge>
      </Grid.Col>
    </>
  )
}